import { Option } from "../common/OptionInput";

export const LinkTarget = ({ linkOpen, setLinkOpen }) => {

    const linkTargetChange = (e) => {
        setLinkOpen(e.target.value)
    }

    return (
        <div className="modalContentWrapper">
            <Option id={"blank"} onChange={linkTargetChange} text={"In new tab"} value={"_blank"} checked={linkOpen} />
            <Option id={"self"} onChange={linkTargetChange} text={"In same tab"} value={"_self"} checked={linkOpen} />
        </div>
    )
}